import ManageWarehouseForm from '@/PageComponents/Warehouse/ManageWarehouseForm'
import SettingsMenu from '@/components/settings/menu'
import { useRouter } from "next/router"
import Fetch from "@/utils/Fetch"
import { Warehouse } from "@/interfaces/api/models"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from '@tanstack/react-router'

const EditWarehouse = () => {

    const router = useRouter();
    const { id } = router.query as any; // TODO(tanstack-router): verify router.query → useParams/useSearch

    let currPath = '';
    if (router) {
        currPath = router.asPath;
    }

    const { data: warehouse } = useQuery<Warehouse>(
        ['warehouse', id],
        () => Fetch.get({ url: '/Warehouse', params: { id } }),
        { enabled: !!id }
    );

    if (!warehouse) return null;

    return (
        <div className="settings-container">
    
            <div className="row">
                <SettingsMenu urlPath={currPath} />
                <div className="settings-card">
                    <ManageWarehouseForm
                        warehouse={warehouse}
                        isNew={false}
                    />
                </div>
            </div>

            <style jsx>{`
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        .type-switch {
          position: absolute;
          top: 1.5rem;
          left: 580px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
        </div>
    );
}

export default EditWarehouse;

export const Route = createFileRoute('/_authenticated/settings/warehouse/$id')({ component: EditWarehouse })
